import * as JSZip from "jszip";

export const zip = {
  methods: {
    async zipDirectory(data) {
      var zip = new JSZip();
      var promises = data.droppedDirectory.map(async (file) => {
        var result = await this.readFile(file);
        var path = file.fullPath;
        zip.file(path, result);
        return new Promise((res) => {
          res(result);
        });
      });
      let dirName = data.droppedDirectory[0].fullPath;

      dirName = dirName.split("/")[0];
      await Promise.all(promises);
      const zipBlob = await zip.generateAsync({
        type: "blob",
        compression: "DEFLATE",
      });
      return new File([zipBlob], dirName);
    }
  }
}
